import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FiltersModel} from "../../common/models/filters.model";
import {MatDrawer} from "@angular/material/sidenav";
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {PlanningService} from "../../../suaps/common/services/planning/planning.service";
import {ActiviteService} from "../../../suaps/common/services/activite/activite.service";
import {Activite} from "../../../suaps/common/services/activite/activite.model";
import {SubSink} from "@Common/core/utils/subsink";
import {Day, DayEnum, TypeCours} from "../../../suaps/common/services/planning/plannig.model";

@Component({
  selector: 'app-filter-pan',
  templateUrl: './filter-pan.component.html',
  styleUrls: ['./filter-pan.component.scss']
})
export class FilterPanComponent implements OnInit {
  @Input() drawer: MatDrawer;
  @Input() filters: FiltersModel;
  @Input() className = null;
  @Output() sendFilters = new EventEmitter<FiltersModel>();
  filtersForm: UntypedFormGroup;
  subSink = new SubSink();
  activites: Activite[] = [];
  activityDays: Day[] = [];
  typeCours = TypeCours;
  dayEnum = DayEnum;
  constructor(private formBuilder: UntypedFormBuilder,
              private planningSvc: PlanningService,
              private activiteSvc: ActiviteService) { }

  ngOnInit(): void {
    this._getActivityDays();
    this._getActivities();
    this._initFiltersForm();
  }

  sendSearch(): void{
    this._setFilters();
    this.sendFilters.emit(this.filters);
    this.drawer.toggle();
  }

  close(): void {
    this.drawer.toggle();
  }

  clearFilters(): void {
    this.filters = <FiltersModel>{typeCours: 0, activites: [], jours: [], categorieCours: 3};
    this._initFiltersForm();
    this.sendFilters.emit(this.filters);
  }

  private _initFiltersForm(): void {
    this.filtersForm = this.formBuilder.group({
      categorieCours: [this.filters.categorieCours, []],
      typeCours: [this.filters.typeCours, []],
      jours: [this.filters.jours, []],
      activites: [this.filters.activites, []],
    });
  }

  private _getActivities(): void {
    this.subSink.sink = this.activiteSvc.listAllItems().subscribe((_data) => this.activites = _data.list);
  }

  private _getActivityDays(): void {
    this.activityDays = this.planningSvc.getActivityDays().filter((day) => day.id !== this.dayEnum.freeAccess);
  }

  private _setFilters(): void {
    this.filters.categorieCours = this.filtersForm.get('categorieCours').value;
    this.filters.typeCours = this.filtersForm.get('typeCours').value;
    this.filters.jours = this.filtersForm.get('jours').value;
    this.filters.activites = this.filtersForm.get('activites').value;
  }

}
